import React from 'react';
import { money } from '../../utils/helpers';
import { lineBasisText, lineCountText, lineRangeText } from '../../utils/costLines';

// Phone list of a booking's lines with their live numbers (see the desktop one).
export default function CostLinesBreakdownMobile({ lines, fnName }) {
  if (!lines || !lines.length) return null;
  return (
    <div className="mn-breakdown m">
      {lines.map(l => {
        const countText = lineCountText(l, l.m);
        return (
          <div key={l.CostLineId} className="mn-breakdown-line">
            <div>
              <strong>{l.Title}</strong>
              <div className="muted">
                {[l.FunctionId ? fnName(l.FunctionId) : null, lineBasisText(l, l.m, money)].filter(Boolean).join(' · ')}
              </div>
              {countText && <div className="muted">{countText}</div>}
              {/* "if needed" / "up to 12,000" - what this line says of itself. */}
              {(l.m.optional || l.m.ranged) && <div className="muted">{lineRangeText(l, l.m, money)}</div>}
            </div>
            <strong className={l.m.optional ? 'muted' : undefined}>{money(l.m.optional ? l.m.maxAmount : l.m.amount)}</strong>
          </div>
        );
      })}
    </div>
  );
}
